import { createContext, useContext, ReactNode, useState } from 'react';

interface AutoScrollContextType {
  isAutoScrollEnabled: boolean;
  setIsAutoScrollEnabled: (value: boolean) => void;
}

const AutoScrollContext = createContext<AutoScrollContextType | undefined>(undefined);

export function AutoScrollProvider({ children }: { children: ReactNode }) {
  const [isAutoScrollEnabled, setIsAutoScrollEnabled] = useState(true);

  return (
    <AutoScrollContext.Provider value={{ isAutoScrollEnabled, setIsAutoScrollEnabled }}>
      {children}
    </AutoScrollContext.Provider>
  );
}

export function useAutoScroll() {
  const context = useContext(AutoScrollContext);
  if (context === undefined) {
    throw new Error('useAutoScroll must be used within an AutoScrollProvider');
  }
  return context;
}
